var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 18,
    viewBox: "0 0 36 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.5875 8.00458L35.5863 8.00325L28.2383 0.690745C27.6879 0.142941 26.7975 0.144979 26.2496 0.695526C25.7017 1.246 25.7038 2.13637 26.2543 2.68424L31.1877 7.59375H1.40625C0.629578 7.59375 0 8.22332 0 9C0 9.77667 0.629578 10.4062 1.40625 10.4062H31.1876L26.2543 15.3157C25.7039 15.8636 25.7017 16.754 26.2496 17.3045C26.7976 17.8551 27.688 17.857 28.2384 17.3092L35.5864 9.99674L35.5876 9.99541C36.1384 9.44571 36.1366 8.55246 35.5875 8.00458Z",
    fill: "#020529"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right_arrow.b069dca8340833e887057fd8055447e2.svg";
export { ForwardRef as ReactComponent };